<!-- <div class="mainClass" style="padding-top: 10vh;"> -->

  <div class="row" *ngIf="role == 'admin'">
    <div class="col-sm-4">
      <nb-card class="dashboard store-card">
        <nb-card-body>
          <h4 class="card-title">Store Count</h4>
          <p class="card-text">{{storeData}}</p>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-sm-4">
      <nb-card class="dashboard user-card">
        <nb-card-body>
          <h4 class="card-title">User Count</h4>
          <p class="card-text">{{userData}}</p>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-sm-4">
      <nb-card class="dashboard visit-card">
        <nb-card-body>
          <h4 class="card-title">User Visit Count</h4>
          <p class="card-text">{{userVisitData}}</p>
        </nb-card-body>
      </nb-card>
    </div>
  </div>


<div class="row" *ngIf="role =='manager'">

  <div class="col-sm-4 mt-3 ">
    <nb-card class="dashboard">
      <nb-card-body>
        <h4>Store Count:{{ManagerStoreData?.length}} </h4>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-sm-4 mt-3">
    <nb-card class="dashboard">
      <nb-card-body>
        <h4>User Visit Count:{{ManagerUserData?.length}}</h4>
      </nb-card-body>
    </nb-card>
  </div>

</div>
<div class="row dashboard-settings-row" *ngIf="role == 'admin'">
  <div class="col-sm-6 col-lg-6 mb-3">
    <nb-card class="card2 settings-card">
      <nb-card-body>
        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label">Email Password Login Type</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="loginToggleValue" (ngModelChange)="toggle()" class="mr-2"></nb-toggle>
          </div>
        </div>
        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label">Email Password Signup Type</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="signupToggleValue" (ngModelChange)="signupToggle()" class="mr-2"></nb-toggle>
          </div>
        </div>

        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label text-nowrap">Require SMS phone validation at signup</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="signupSmsValidationToggleValue" (ngModelChange)="signupSmsValidationToggle()" class="mr-2"></nb-toggle>
          </div>
        </div>
        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label text-nowrap">Require email validation at signup</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="signupEmailValidationToggleValue" (ngModelChange)="signupEmailValidationToggle()" class="mr-2"></nb-toggle>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <p class="text-muted small mb-0">
              Applies to all web and app signups. Raise the Minimum Supported App Version (Android/iOS) before enabling.
            </p>
          </div>
        </div>
        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label text-nowrap">Enable Ingredients &amp; Allergens on products</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="productAllergensEnabledToggleValue" (ngModelChange)="productAllergensEnabledToggle()" class="mr-2"></nb-toggle>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <p class="text-muted small mb-0">
              When off, the section is hidden in product forms and its CSV columns are ignored on import. Existing data is kept.
            </p>
          </div>
        </div>
        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label text-nowrap">Enable Nutrition Facts on products</h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <nb-toggle [(ngModel)]="productNutritionEnabledToggleValue" (ngModelChange)="productNutritionEnabledToggle()" class="mr-2"></nb-toggle>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <p class="text-muted small mb-0">
              When off, the section is hidden in product forms and its CSV columns are ignored on import. Existing data is kept.
            </p>
          </div>
        </div>

        <div class="row mt-3 settings-toggle-row align-items-center">
          <div class="col-8">
            <h4 class="mb-0 settings-label">Finding Radius <small>(km)</small></h4>
          </div>
          <div class="col-4 d-flex justify-content-end">
            <input style="background-color: white; width: 80%;" type="number" nbInput [(ngModel)]="radius"
              (keyup)="enterRadius()" oninput="this.value = this.value.replace(/[^0-9]/g, '').substring(0, 6);" />
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-sm-6 col-lg-6 mb-3">
    <nb-card class="card2 settings-card">
    <nb-card-body>
      <h4 class="mb-3">App Version Control</h4>
      <p class="text-muted small mb-3">
        Configure minimum supported app versions for force-update. Leave a version blank to disable enforcement for that platform.
      </p>

      <h5 class="mb-2">Android</h5>
      <div class="row mt-2 align-items-start">
        <div class="col-sm-6">
          <label class="d-block mb-1">Minimum Supported Version</label>
          <input
            class="w-100"
            style="background-color: white;"
            type="text"
            nbInput
            placeholder="e.g. 1.1.1"
            [(ngModel)]="minAppVersionAndroid"
            (blur)="validateAppVersionField('minAppVersionAndroid')"
            (ngModelChange)="validateAppVersionField('minAppVersionAndroid')" />
          <small *ngIf="appVersionErrors.minAppVersionAndroid" class="text-danger d-block mt-1">
            {{ appVersionErrors.minAppVersionAndroid }}
          </small>
        </div>
        <div class="col-sm-6">
          <label class="d-block mb-1">Latest Version <small class="text-muted">(informational)</small></label>
          <input
            class="w-100"
            style="background-color: white;"
            type="text"
            nbInput
            placeholder="e.g. 1.1.1"
            [(ngModel)]="latestAppVersionAndroid"
            (blur)="validateAppVersionField('latestAppVersionAndroid')"
            (ngModelChange)="validateAppVersionField('latestAppVersionAndroid')" />
          <small *ngIf="appVersionErrors.latestAppVersionAndroid" class="text-danger d-block mt-1">
            {{ appVersionErrors.latestAppVersionAndroid }}
          </small>
        </div>
      </div>

      <h5 class="mb-2 mt-4">iOS</h5>
      <div class="row mt-2 align-items-start">
        <div class="col-sm-6">
          <label class="d-block mb-1">Minimum Supported Version</label>
          <input
            class="w-100"
            style="background-color: white;"
            type="text"
            nbInput
            placeholder="e.g. 1.1.1"
            [(ngModel)]="minAppVersionIOS"
            (blur)="validateAppVersionField('minAppVersionIOS')"
            (ngModelChange)="validateAppVersionField('minAppVersionIOS')" />
          <small *ngIf="appVersionErrors.minAppVersionIOS" class="text-danger d-block mt-1">
            {{ appVersionErrors.minAppVersionIOS }}
          </small>
        </div>
        <div class="col-sm-6">
          <label class="d-block mb-1">Latest Version <small class="text-muted">(informational)</small></label>
          <input
            class="w-100"
            style="background-color: white;"
            type="text"
            nbInput
            placeholder="e.g. 1.1.1"
            [(ngModel)]="latestAppVersionIOS"
            (blur)="validateAppVersionField('latestAppVersionIOS')"
            (ngModelChange)="validateAppVersionField('latestAppVersionIOS')" />
          <small *ngIf="appVersionErrors.latestAppVersionIOS" class="text-danger d-block mt-1">
            {{ appVersionErrors.latestAppVersionIOS }}
          </small>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <label class="d-block mb-1">Update Required Message <small class="text-muted">(optional)</small></label>
          <textarea
            class="w-100"
            style="background-color: white; min-height: 80px;"
            nbInput
            rows="3"
            placeholder="Custom message shown when a force update is required. Leave blank to use the app default message."
            [(ngModel)]="forceUpdateMessage"></textarea>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">
          <button
            nbButton
            status="primary"
            type="button"
            [disabled]="hasAppVersionValidationErrors"
            (click)="saveAppVersionSettings()">
            Save App Version Settings
          </button>
        </div>
      </div>
    </nb-card-body>
    </nb-card>
  </div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>